import { useContext } from 'react';

import { Progress } from '@atom/mui';

import TreeContext, { Tree } from './TreeContext';
import TreeList from './TreeList';

import classes from './inventoryAssetTree.module.css';

export interface Props {
  level: number;
  loadingTree: boolean;
  trees: Tree[];
}

const TreeView = ({ level, loadingTree, trees }: Props) => {
  const { rootTree } = useContext(TreeContext);

  return (
    <>
      {!rootTree || loadingTree ? (
        <div className={classes.progressContainer}>
          <Progress style={{ flex: 1 }} />
        </div>
      ) : (
        <TreeList level={level} trees={trees} path={[]} assetPath={[]} />
      )}
    </>
  );
};

export default TreeView;
